import React from 'react';

import cn from 'classnames';
import { EmblaOptionsType } from 'embla-carousel';

import { IJournalEvent } from '@entities/eventJournal';
import { Icon, EmblaCarousel, ImageDescription, UiText } from '@shared/ui';
import { useLightBoxControl } from '@shared/ui';

import cls from './PhotoEventJournalItem.module.css';

interface EventJournalItemProps {
    classes?: string;
    photoEvents: IJournalEvent[];
    isOnlyPhoto: boolean;
    isExport?: boolean;
}

export const PhotoEventJournalItem = ({
    classes,
    photoEvents,
    isOnlyPhoto,
    isExport = false,
}: EventJournalItemProps) => {
    const { onShowLightBox } = useLightBoxControl();

    const OPTIONS: EmblaOptionsType = {};
    const SLIDES = photoEvents.map((event) => ({
        id: event.id,
        image: event.imageUrl,
        descriptionSlot: <ImageDescription description={event.description} author={event.author} />,
        exportDescription: { description: event.description, author: event.author },
    }));

    const files = photoEvents.map((event) => ({
        id: event.id,
        fileSrc: event.imageUrl,
        mimeType: 'image',
        description: event.description,
        author: event.author,
        fileName: event.name,
    }));

    if (isExport) {
        return (
            <div className={cls.exportMode}>
                {SLIDES.map(({ image, exportDescription, id }, index) => (
                    <div className={cls.exportImageWrapper} key={id}>
                        <img src={image} alt="" className={cls.exportImage} />
                        <div className={cls.descriptionWrapper}>
                            {exportDescription.description && (
                                <UiText align="center">{exportDescription.description}</UiText>
                            )}
                            {exportDescription.author && (
                                <div className={cls.author}>
                                    <UiText>{exportDescription.author.name}</UiText>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={cn(cls.EventJournalItem, [classes])}>
            {isOnlyPhoto ? (
                <div className={cls.onlyPhoto}>
                    {SLIDES.map(({ image, descriptionSlot, id }) => (
                        <div
                            key={id}
                            className={cls.imageWrapper}
                            onClick={() =>
                                onShowLightBox({
                                    id,
                                    newFiles: files,
                                })
                            }
                        >
                            {descriptionSlot}

                            <img src={image} alt="" />
                        </div>
                    ))}
                </div>
            ) : (
                <EmblaCarousel
                    nextIcon={<Icon iconName="carouselNext" />}
                    prevIcon={<Icon iconName="carouselPrev" />}
                    slides={SLIDES}
                    options={OPTIONS}
                    slideHeight={SLIDES.length === 1 ? 239 : 206}
                    onShowLightBox={onShowLightBox}
                    files={files}
                />
            )}
        </div>
    );
};
